module.exports = __webpack_public_path__ + "img/bu-dotted.a4f9aa17.svg";